import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Copy, Check, Link } from 'lucide-react'

interface StaffLoginLinkProps {
  restaurantId: string
}

export function StaffLoginLink({ restaurantId }: StaffLoginLinkProps) {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  // Generate the full URL
  const baseUrl = window.location.origin
  const staffLoginUrl = `${baseUrl}/staff-login?restaurant=${restaurantId}`

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(staffLoginUrl)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Failed to copy:', error)
    }
  }

  return (
    <Card className="mb-6 bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Link className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          <CardTitle className="text-lg">{t('staff.loginLink')}</CardTitle>
        </div>
        <CardDescription>
          {t('staff.loginLinkDescription') || 'Share this link with your staff to allow them to log in'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2">
          <Input
            value={staffLoginUrl}
            readOnly
            className="font-mono text-sm bg-white dark:bg-gray-900"
            onClick={(e) => e.currentTarget.select()}
          />
          <Button
            variant="outline"
            size="icon"
            onClick={handleCopy}
            title={copied ? 'Copied!' : 'Copy to clipboard'}
          >
            {copied ? (
              <Check className="w-4 h-4 text-green-600" />
            ) : (
              <Copy className="w-4 h-4" />
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
